import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  status: string;
}

const STATUS_CLASS: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-700',
  open: 'bg-green-100 text-green-700',
  closed: 'bg-yellow-100 text-yellow-700',
  active: 'bg-blue-100 text-blue-700',
  knockout: 'bg-purple-100 text-purple-700',
  finished: 'bg-gray-100 text-gray-500',
};

export default function LeagueStatusBadge({ status }: Props) {
  const { t } = useTranslation();
  const className = STATUS_CLASS[status] ?? 'bg-gray-100 text-gray-700';
  const label = t(`status.${status}`, { defaultValue: status });
  return (
    <span className={`badge ${className}`}>
      {label}
    </span>
  );
}
